var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v8.189l-2.72-2.719c-.293-.293-.767-.293-1.06,0-.293.293-.293.767,0,1.06l4,4c.293.293.767.293,1.06,0l4-4c.293-.293.293-.767,0-1.06-.293-.293-.767-.293-1.06,0l-2.72,2.719V.75ZM1.5,10.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4c0,.729.29,1.429.805,1.945.516.515,1.216.805,1.945.805h14c.729,0,1.429-.29,1.945-.805.515-.516.805-1.216.805-1.945v-4c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4c0,.332-.132.649-.366.884-.235.234-.552.366-.884.366H2.75c-.332,0-.649-.132-.884-.366-.234-.235-.366-.552-.366-.884v-4Z",
    fill: "#01294e",
    fillRule: "evenodd",
    strokeWidth: 0
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.a080f3fb725655bcd70173adc4b12dc0.svg";
export { ForwardRef as ReactComponent };